import React from 'react';
import Head from "../../../components/sectionHead";
import JIT from '../../../assets/images/jit.png';
import Title from 'antd/lib/typography/Title';
import IIITB from '../../../assets/images/iiitb.png';
import MEITY from '../../../assets/images/meity.png';
import C_Camp from '../../../assets/images/c-camp.png';
import RAFTAAR from '../../../assets/images/raftaar.png';
import UASD from '../../../assets/images/uas_dharawad.png';
import INDIA from '../../../assets/images/startup_india.png';
import KARNATAKA from '../../../assets/images/startup_karnataka.png';
import KWALITY from '../../../assets/images/kwality.png';
import RAVI from '../../../assets/images/ravi.png';
import NRV from '../../../assets/images/nrv.png';
import VILCART from '../../../assets/images/vilcart.png';
import SNN from '../../../assets/images/snn.png';
import SUJATHA from '../../../assets/images/sujatha.png';
import SUPERSTORE from '../../../assets/images/superstore.png';
import SKANDA from '../../../assets/images/skanda.png';
import MANYAM from '../../../assets/images/manyam.png';
import UTTARAN from '../../../assets/images/uttaran.png';
import WATEHOLE from '../../../assets/images/watehole.png';
import KALPAMITRA from '../../../assets/images/kalpamitra.png';
import HUNGUNDU from '../../../assets/images/hungundu.png';
import RELA from '../../../assets/images/rela.png';
import VISHNUMURTHY from '../../../assets/images/vishnumurthy.png';
import { Carousel } from 'antd';
import { Row, Col } from "antd";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

export default function Partners() {
    return (
        <React.Fragment>

            <div id="pthead" className="pthead">
                <Head title={"Engagements"} />
            </div>
            <div id="partners" className="partners">
                <div className="web-visible-partners">


                    {/* ROW 1 - Customers */}
                    <Row gutter={[20, 40]} align="middle">
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Title className="partnerTitle">
                                <span className="first_word">Our</span> Customers
                            </Title>
                        </Col>

                        <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                            <Carousel autoplay arrows={true} prevArrow={<LeftOutlined />} nextArrow={<RightOutlined />} dots={false}>
                                <div className="inside-carousel">
                                    <img src={KWALITY} alt="KWALITY" />
                                    <img src={RAVI} alt="RAVI" />
                                    <img src={NRV} alt="NRV" />
                                    <img src={SNN} alt="SNN" />
                                </div>

                                <div className="inside-carousel">
                                    <img src={SUJATHA} alt="SUJATHA" />
                                    <img src={SUPERSTORE} alt="SUPERSTORE" />
                                    <img src={SKANDA} alt="SKANDA" />
                                    <img src={VILCART} alt="VILCART" />
                                </div>
                            </Carousel>
                        </Col>
                    </Row>


                    {/* ROW 2 - Suppliers */}
                    <Row gutter={[20, 40]} align="middle">
                        <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                            <Title className="partnerTitle">
                                <span className="first_word">Our</span> Suppliers
                            </Title>
                        </Col>

                        <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                            <Carousel autoplay arrows={true} prevArrow={<LeftOutlined />} nextArrow={<RightOutlined />} dots={false}>
                                <div className="inside-carousel supplier-carousel">
                                    <img src={MANYAM} alt="MANYAM" />
                                    <img src={UTTARAN} alt="UTTARAN" />
                                    <img src={WATEHOLE} alt="WATEHOLE" />
                                    <img src={KALPAMITRA} alt="KALPAMITRA" />
                                </div>

                                <div className="inside-carousel supplier-carousel">
                                    <img src={HUNGUNDU} alt="HUNGUNDU" />
                                    <img src={RELA} alt="RELA" />
                                    <img src={VISHNUMURTHY} alt="VISHNUMURTHY" />
                                </div>
                            </Carousel>
                        </Col>
                    </Row>

                    {/* ROW 3 - Partners*/}
                    <Row gutter={[20, 40]} align="middle">
                        <Col xs={24} sm={24} md={24} lg={6} xl={6} >
                            <Title className="partnerTitle">
                                <span className="first_word">Our</span> Partners
                            </Title>
                        </Col>

                        <Col xs={24} sm={24} md={18} lg={18} xl={18}>
                            <Carousel autoplay arrows={true} prevArrow={<LeftOutlined />} nextArrow={<RightOutlined />} dots={false}>
                                <div className="inside-carousel">
                                    <img src={INDIA} alt="INDIA" />
                                    <img src={C_Camp} alt="C_Camp" />
                                    <img src={MEITY} alt="MEITY" />
                                    <img src={RAFTAAR} alt="RAFTAAR" />
                                </div>

                                <div className="inside-carousel">
                                    <img src={KARNATAKA} alt="KARNATAKA" />
                                    <img src={JIT} alt="JIT" />
                                    {/* <img src={SVCE} alt="SVCE" /> */}
                                    <img src={UASD} alt="UASD" />
                                    {/* <img src={UASB} alt="UASB" /> */}
                                    <img src={IIITB} alt="IIITB" />
                                </div>
                            </Carousel>
                        </Col>
                    </Row>
                </div>

                <div className="partners-phone-display">

                    {/* Customers */}
                    <Title className="partnerTitle">
                        <span className="first_word">Our</span> Customers
                    </Title>

                    <Carousel autoplay dots={false}>
                        <div className="partner-carousel-item">
                            <img src={KWALITY} alt="KWALITY" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={RAVI} alt="RAVI" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={NRV} alt="NRV" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={SNN} alt="SNN" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={SUJATHA} alt="SUJATHA" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={SUPERSTORE} alt="SUPERSTORE" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={SKANDA} alt="SKANDA" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={VILCART} alt="VILCART" />
                        </div>
                    </Carousel>

                    {/* Suppliers */}
                    <Title className="partnerTitle">
                        <span className="first_word">Our</span> Suppliers
                    </Title>

                    <Carousel autoplay dots={false}>
                        <div className="partner-carousel-item">
                            <img src={MANYAM} alt="MANYAM" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={UTTARAN} alt="UTTARAN" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={WATEHOLE} alt="WATEHOLE" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={KALPAMITRA} alt="KALPAMITRA" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={HUNGUNDU} alt="HUNGUNDU" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={RELA} alt="RELA" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={VISHNUMURTHY} alt="VISHNUMURTHY" />
                        </div>
                    </Carousel>

                    {/* Partners */}
                    <Title className="partnerTitle">
                        <span className="first_word">Our</span> Partners
                    </Title>

                    <Carousel autoplay dots={false}>
                        <div className="partner-carousel-item">
                            <img src={INDIA} alt="INDIA" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={C_Camp} alt="C_Camp" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={MEITY} alt="MEITY" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={RAFTAAR} alt="RAFTAAR" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={KARNATAKA} alt="KARNATAKA" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={JIT} alt="JIT" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={UASD} alt="UASD" />
                        </div>
                        <div className="partner-carousel-item">
                            <img src={IIITB} alt="IIITB" />
                        </div>
                    </Carousel>

                </div>
            </div>
        </React.Fragment>
    );
}